import { useQuery, UseQueryResult } from 'react-query';
import { Report } from '_types';
import { reports } from '../../services/nestApiService';

export const useReportsQuery = (): UseQueryResult<Report[]> =>
  useQuery(['reports'], () => reports.list(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
